module.exports = __webpack_public_path__ + "img/15_8.421a24f4.png";